import { Stack } from '@mui/material';

import ReportProblem from '@/shared/ui/icons/ReportProblem.svg';

import { SIDEBAR_EXPANDED_WIDTH, SIDEBAR_WIDTH } from '@/shared/ui/constants';

import { useRole } from '@/entities/user';

import { LogoutButton } from '@/features/auth';

import { getNavItems } from '../model/getNavItems';
import { useSidebar } from '../model/useSidebar';
import { Logo } from './Logo';
import { NavActionItem } from './NavActionItem';
import { NavItems } from './NavItems';
import { Overlay } from './Overlay';

interface IProps {
  onReportProblem: () => void;
}

/**
 * Боковое меню
 * @param root0 - пропсы
 * @param root0.onReportProblem - запуск флоу «Сообщить о проблеме»
 */
export const Sidebar = ({ onReportProblem }: IProps) => {
  const role = useRole();
  const { isExpanded, isLogoVisible, handleMouseEnter, handleMouseLeave } =
    useSidebar();
  const navItems = getNavItems(role);

  /**
   * Клик по пункту происходит при hover-развёрнутой рельсе — сворачиваем её,
   * иначе рельса на 316px и затемнение попадут в кадр скриншота
   */
  const handleReportProblem = () => {
    handleMouseLeave();
    onReportProblem();
  };

  return (
    <>
      <Stack
        component='nav'
        position='fixed'
        left={0}
        top={0}
        width={isExpanded ? SIDEBAR_EXPANDED_WIDTH : SIDEBAR_WIDTH}
        height='100%'
        sx={{
          background: `linear-gradient(135deg, #242269 0%, #121533 25.5%, #121533 75%, #112d7a 100%)`,
          transition: 'width 0.5s ease-in-out',
          zIndex: 1100,
          overflow: 'hidden'
        }}
        alignItems='center'
        justifyContent='space-between'
        py={10}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <Stack gap={4} sx={{ width: '100%', overflow: 'hidden' }}>
          <Logo isExpanded={isExpanded} isVisible={isLogoVisible} />
          <NavItems
            items={navItems}
            isExpanded={isExpanded}
            actionSlot={
              <NavActionItem
                Icon={ReportProblem}
                label='Сообщить о проблеме'
                isExpanded={isExpanded}
                onClick={handleReportProblem}
              />
            }
          />
        </Stack>
        <Stack
          sx={{
            width: '100%',
            alignItems: isExpanded ? 'flex-start' : 'center'
          }}
        >
          <LogoutButton widthText={isExpanded} />
        </Stack>
      </Stack>
      <Overlay isVisible={isExpanded} />
    </>
  );
};
